import BaseUIAboutView from 'xui/modules/setting/BaseUIAboutView'
import * as util from 'x/utils/util'
import p from 'x/config/platform-specific'

class AboutView extends BaseUIAboutView {
  static displayName = 'AboutView'

  inProcess: boolean

  _renderVersionDetail = () => null

  componentDidMount() {
    // getDeviceInfo().then((deviceInfo) => {
    //   // console.log('AboutView componentDidMount deviceInfo => ', deviceInfo)
    //   this.setState({ deviceInfo })
    // })
    // this._initVersionNumber()
    this.xsellyToTheMoon()
  }

  xsellyToTheMoon = () => {
    if (!util.isDevMode()) {
      return
    }
    const randomNumber = Math.floor(Math.random() * 10)
    // console.log('randomNumber => ', randomNumber)
    if (randomNumber === 8) {
      p.op.showConfirmationOkOnly('Is Web Dev Mode Only', 'Xselly To The Moon 🚀🌕\n August 1, 2018 To September 30, 2025 By Artid 🌞')
    }
  }
}

export default AboutView
